<style scoped>
</style>

<template>
  <div style="background:#fff;padding:15px;">
    <Breadcrumb style="margin-left:15px;">
        <BreadcrumbItem to="/vreleasemanage">首页</BreadcrumbItem>
        <BreadcrumbItem v-if="!isUpdate">申请发布</BreadcrumbItem>
        <BreadcrumbItem v-if="isUpdate">更新申请信息</BreadcrumbItem>
    </Breadcrumb>
    <Form :model="formItem" :label-width="80" style="margin-top:20px;">
        <FormItem label="组件名称" required>
            <Input v-model="formItem.name" placeholder="请输入组件名称"></Input>
        </FormItem>
        <FormItem label="版本" required>
            <Input v-model="formItem.version" placeholder="请输入组件版本"></Input>
        </FormItem>
        <FormItem label="构建号" required>
            <Input v-model="formItem.buildcode" type="number" placeholder="构建号"></Input>
        </FormItem>
        <FormItem label="发版类型" required>
            <RadioGroup v-model="formItem.type" v-if="!isExamine">
                <Radio label="1">正式版本</Radio>
                <Radio label="2">sp版本</Radio>
            </RadioGroup>
            <Tag v-if="formItem.type==1" color="green" >正式版本</Tag>
            <Tag v-if="formItem.type==2" color="orange" >sp版本</Tag>
        </FormItem>
        <FormItem label="内容清单" required>
            <Row v-for="(item, index) in formItem.contents" v-bind:key="index" style="margin-top:5px;">
                <Col span="2">
                    <Select v-model="item.type">
                        <Option value="0">新增</Option>
                        <Option value="1">修复</Option>
                        <Option value="2">优化</Option>
                    </Select>
                </Col>
                <Col span="12">
                    <Input  style="margin-left:15px;" v-model="item.description" placeholder="请输入说明描述" ></Input>
                </Col>
                <Col span="2" style="text-align: center;">
                    <Button v-if="isDeveloper" @click="deleteRow(item,index)"  type="error"  icon="ios-backspace-outline" >
                    </Button>
                </Col>
            </Row>

            <Button v-if="isDeveloper" @click="addNewContent" style="margin-top:15px;width:220px;"  type="warning">
                <Icon type="md-add" />增加记录
            </Button>
        </FormItem>

        <Divider v-if="isExamine" orientation="left">审核信息</Divider>

        <Steps :current="formItem.step" direction="vertical" style="padding:0px 80px; margin-top:44px; margin-bottom: 50px;width:700px;">
            <template v-for="(it, index) in testContents" >
                <Step   v-if="(index < 4)"
                        :key="index" 
                        :title="it" >
                    <template slot="content">
                        <span v-if="index == 0">
                             待审核
                        </span>
                        <span v-else-if="index < formItem.step">
                            <Alert type="success" show-icon>审核通过</Alert>
                        </span>
                        <span v-else-if="index == formItem.step">
                            <Alert v-if="examines.info.state == 0" type="warning" show-icon>
                                 审核中
                            </Alert>
                            <template v-if="(examines.info.state == 2)||(examines.info.state == -1)">
                                <Alert v-for="(jt, jndex) in examines.reasons" :key="jndex" type="error" show-icon>
                                    {{ jt.reason }}
                                </Alert>
                                <Form  v-if="examines.info.type != 0">
                                    <FormItem  >
                                        <Upload
                                                ref="uploadAttacher"
                                                :default-file-list="uploadList"
                                                :action="filePushUpload.uploadurl"
                                                :data="filePushUpload.fileUploadParams"
                                                :headers="filePushUpload.headers"
                                                :show-upload-list="false"
                                                :before-upload="handleBeforeUpload"
                                                :on-success="onAttachUploadSuccess"
                                                :on-error="onAttachUploadError" >
                                                <Button icon="ios-cloud-upload-outline">附件上传</Button>
                                        </Upload>
                                        <div v-if="filePushUpload.result.id != null" >
                                            <a :href="attachurlprefix + '?id='+filePushUpload.result.id" >
                                                <Icon type="ios-link" />{{ filePushUpload.result.id }}
                                            </a>
                                            <Button @click="clearUploadList()" icon="ios-backspace-outline" type="text" ></Button>
                                        </div>
                                    </FormItem>
                                    <FormItem label="备注："  >
                                        <Input v-model="examineForm.mark" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="备注描述..."></Input>
                                    </FormItem>
                                    <FormItem   >
                                        <Button @click="savingAndProcess"  :disabled="savingBtnIsDisabled"  type="primary">{{ savingBtnText }}</Button>
                                    </FormItem>
                                </Form>
                            </template>
                        </span>
                        <span v-else >
                            未开始
                        </span>
                    </template>
                </Step>
                <Step
                     v-if="(index >= 4) && (formItem.type != 2)"
                        :key="index" 
                        :title="it">
                        <template slot="content">
                            <span v-if="index < formItem.step">
                                <Alert type="success" show-icon>审核通过</Alert>
                            </span>
                            <span v-else-if="index == formItem.step">
                            <Alert v-if="examines.info.state == 0" type="warning" show-icon>
                                 审核中
                            </Alert>
                            <template v-if="(examines.info.state == 2)||(examines.info.state == -1)">
                                <Alert v-for="(jt, jndex) in examines.reasons" :key="jndex" type="error" show-icon>
                                    {{ jt.reason }}
                                </Alert>
                                <Form  v-if="examines.info.type != 0">
                                    <FormItem  >
                                        <Upload
                                                ref="uploadAttacher"
                                                :default-file-list="uploadList"
                                                :action="filePushUpload.uploadurl"
                                                :data="filePushUpload.fileUploadParams"
                                                :headers="filePushUpload.headers"
                                                :show-upload-list="false"
                                                :before-upload="handleBeforeUpload"
                                                :on-success="onAttachUploadSuccess"
                                                :on-error="onAttachUploadError" >
                                                <Button icon="ios-cloud-upload-outline">附件上传</Button>
                                        </Upload>
                                        <div v-if="filePushUpload.result.id != null" >
                                            <a :href="attachurlprefix + '?id='+filePushUpload.result.id" >
                                                <Icon type="ios-link" />{{ filePushUpload.result.id }}
                                            </a>
                                            <Button @click="clearUploadList()" icon="ios-backspace-outline" type="text" ></Button>
                                        </div>
                                    </FormItem>
                                    <FormItem label="备注："  >
                                        <Input v-model="examineForm.mark" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="备注描述..."></Input>
                                    </FormItem>
                                    <FormItem   >
                                        <Button @click="savingAndProcess"  :disabled="savingBtnIsDisabled"  type="primary">{{ savingBtnText }}</Button>
                                    </FormItem>
                                </Form>
                            </template>
                            <div v-else-if="!isDeveloper">
                                    <Alert  type="warning" show-icon>
                                            待提交审核
                                    </Alert>
                            </div>
                        </span>
                            <span v-else >
                                未开始
                            </span>
                        </template>
                </Step>
            </template>
            
        </Steps>

        <FormItem>
            <Button v-if="isUpdate && !isExamine" :disabled="saveBtnIsDisabled" @click="updateForm" type="primary">{{ saveBtnText }}</Button>
            <Button v-if="!isUpdate && !isExamine" :disabled="saveBtnIsDisabled" @click="saveForm" type="primary">{{ saveBtnText }}</Button>
            <Button v-if="!isExamine" type="default" style="margin-left: 8px;" :disabled="saveBtnIsDisabled" @click="operationForm" >{{ saveAndProcessBtnText }}</Button>
            <Button v-if="isExamine && (formItem.step == 1) && isDeveloper" :disabled="saveBtnIsDisabled" @click="updateAndReCommitForm" type="info">{{ saveAndProcessBtnText }}</Button>
        </FormItem>
    </Form>
  </div>
</template>

<script>

import dayjs from 'dayjs';

export default {
  components: {
  },
  data() {
    return {
        saveBtnIsDisabled:false,
        saveBtnText:"保存",
        saveAndProcessBtnText:"保存并提交至审核",

        savingBtnIsDisabled:false,
        savingBtnText:"提交至审核",


        formItem:{
            type:'1',
            contents:[]
        },

        examines:{
            info:{},
            reasons:[],
        },


        testContents:[
            "准备审核","基础信息审核","单元测试审核","人工测试审核","集成测试审核","模拟升级测试审核"
        ],

        isUpdate:false,
        isExamine:false,

        examineForm:{
        },
        attachurlprefix:"",
        filePushUpload: {
            hasUpload: false,
            hasPushCerUpload: false,
            fileUploadParams: {
                clientguid: this.$route.params.projectguid,
                userguid: localStorage.userguid
            },
            headers: {
                Authorization: localStorage.token
            },
            uploadurl: this.$axios.defaults.baseURL + "/mqms/file/upload",
            result:{},
        },
        uploadList:[],

        isDeveloper:false,
    };
  },
  methods: {
    initRuntimeRole(){
        this.attachurlprefix = this.$axios.defaults.baseURL + '/mqms/file/downloadwithoutcode';
        let moduleid = this.$route.params.id || "";
        let isExamine = this.$route.params.isExamine || "";

        if (moduleid.length > 0) {
            this.isUpdate = true;
        }

        if (isExamine == 'yes') {
            this.isExamine = true;
        }

        if (!this.isUpdate) {
            let form = this.formItem;
            form.buildcode = parseInt(dayjs(new Date()).format("YYYYMMDDHH"));
            this.formItem = form;
        } else {
            let _this = this;
            // 查询待修改的数据
            this.$http.post({
                method: "mqms/moduledist/findrequestbyid",
                params: {id : moduleid},
                success: function (data) {
                    let from = data.obj;
                    from.type = from.type + "";
                    for (let item of data.list) {
                        item.type = item.type + "";
                    }
                    from.contents = data.list || [];
                    _this.formItem = from;
                },
                failure(code, errMsg) {
                    _this.$Message.error({
                        content:errMsg||"数据加载失败"
                    })
                },
            });
        }

        if (this.isExamine && this.isUpdate) {
            let _this = this;
            //如果是审核状态下的修改，需要查询对应的审核信息。
            this.$http.post({
                method: "mqms/moduledist/getAllReasonsByModuleid",
                params: {id : moduleid, state:'0'},
                success: function (data) {
                    _this.examines = data;
                    _this.examineForm.mark = data.info.mark;
                    _this.filePushUpload.result = {
                        id:data.info.fileguid
                    }
                    _this.uploadList.push({
                        'name': data.info.fileguid,
                        'url': 'https://o5wwk8baw.qnssl.com/a42bdcc1178e62b4694c830f028db5c0/avatar'
                    });
                },
                failure(code, errMsg) {
                    _this.$Message.error({
                        content:errMsg||"审核信息加载失败"
                    })
                },
            })
        }


        let user = this.getCurrentUserInfo();
        for (let item of user.roles) {
            if (item == "developer") {
                this.isDeveloper = true;
                break;
            }
        }
    },
    handleBeforeUpload () {
        let check = this.uploadList.length < 1;
        if (!check) {
            this.$Notice.warning({
                title: '最多上传一份附件'
            });
        }
        return check;
    },
    goBack(){
        window.history.go(-1)
    },
    addNewContent(){
        let contents = this.formItem.contents || [];
        contents.push({type:"0"})
        let form = this.formItem;
        form.contents = contents;
        this.formItem = form;
    },
    deleteRow(item,index){
        let _this = this;
        this.$Modal.confirm({
            title: "提示",
            content: "确定要删除吗？",
            onOk: () => {
                let formItem = _this.formItem;
                formItem.contents.splice(index, 1)
                _this.formItem = formItem
            }
        });
    },

    // 保存数据
    validateForm(){
        let form = this.formItem;
        if ((form.name || "").length <= 0) return "组件名称不能为空"
        if ((form.version || "").length <= 0) return "版本号不能为空"
        if ((form.buildcode || "").length <= 0) return "构建号不能为空"
        if ((form.contents || []).length <= 0) return "必须添加至少一条更新内容"
        for (let item of form.contents) {
            if ((item.description||"").length <= 0) {
                return "更新内容描述信息不能为空"
            }
        }
    },
    saveForm(){
        let msg = this.validateForm();
        if ((msg||"").length > 0) {
            this.$Message.error({
                content:msg
            })
            return 
        }
        // 开始提交数据
     
        let loading = this.$Message.loading({
                    content: '正在保存...',
                    duration: 0
                });
        this.saveBtnIsDisabled = true;
        this.saveBtnText = "正在保存...";
        let _this = this;
        this.$http.post({
            method: "mqms/moduledist/saverequest",
            params: this.formItem,
            success: function (data) {
                setTimeout(loading, 0);
                _this.saveBtnIsDisabled = false;
                _this.saveBtnText = "保存";

                _this.$Message.success({
                    content:"保存成功"
                })
                _this.$router.push({
                    name: "vreleasemanage",
                });
            },
            failure(code, errMsg) {
                _this.saveBtnIsDisabled = false;
                _this.saveBtnText = "保存";
                setTimeout(loading, 0);

                _this.$Message.error({
                    content:errMsg||"申请失败"
                })
            },
        });
    },
    updateForm(){
        let msg = this.validateForm();
        if ((msg||"").length > 0) {
            this.$Message.error({
                content:msg
            })
            return 
        }
        // 开始提交数据
     
        let loading = this.$Message.loading({
                    content: '正在保存...',
                    duration: 0
                });
        this.saveBtnIsDisabled = true;
        this.saveBtnText = "正在保存...";
        let _this = this;
        this.$http.post({
            method: "mqms/moduledist/updaterequestbyid",
            params: this.formItem,
            success: function (data) {
                setTimeout(loading, 0);
                _this.saveBtnIsDisabled = false;
                _this.saveBtnText = "保存";

                _this.$Message.success({
                    content:"保存成功"
                })
                _this.$router.push({
                    name: "vreleasemanage",
                });
            },
            failure(code, errMsg) {
                _this.saveBtnIsDisabled = false;
                _this.saveBtnText = "保存";
                setTimeout(loading, 0);

                _this.$Message.error({
                    content:errMsg||"申请失败"
                })
            },
        });
    },

    operationForm(){
        let _this = this;
        let msg = this.validateForm();
        if ((msg||"").length > 0) {
            this.$Message.error({
                content:msg
            })
            return 
        }
        
        this.saveBtnIsDisabled = true;
        this.saveAndProcessBtnText = "处理中...";
        let loading = this.$Message.loading({
                    content: '正在处理...',
                    duration: 0
                });
        if (this.isUpdate) {
            this.$http.post({
                method: "mqms/moduledist/updaterequestbyid",
                params: {
                    ...this.formItem,
                    saveandprocess:"yes",
                },
                success: function (data) {
                    setTimeout(loading, 0);
                    _this.saveBtnIsDisabled = false;
                    _this.saveAndProcessBtnText = "保存并提交至审核";

                    _this.$Message.success({
                        content:"已提交至审核"
                    })
                    _this.$router.push({
                        name: "vreleasemanage",
                    });
                },
                failure(code, errMsg) {
                    _this.saveBtnIsDisabled = false;
                    _this.saveAndProcessBtnText = "保存并提交至审核";
                    setTimeout(loading, 0);

                    _this.$Message.error({
                        content:errMsg||"提交失败"
                    })
                },
            });
        } else {
            this.$http.post({
                method: "mqms/moduledist/saverequest",
                params: {
                    ...this.formItem,
                    saveandprocess:"yes",
                },
                success: function (data) {
                    setTimeout(loading, 0);
                    _this.saveBtnIsDisabled = false;
                    _this.saveAndProcessBtnText = "保存并提交至审核";

                    _this.$Message.success({
                        content:"已提交至审核"
                    })
                    _this.$router.push({
                        name: "vreleasemanage",
                    });
                },
                failure(code, errMsg) {
                    _this.saveBtnIsDisabled = false;
                    _this.saveAndProcessBtnText = "保存并提交至审核";
                    setTimeout(loading, 0);

                    _this.$Message.error({
                        content:errMsg||"提交失败"
                    })
                },
            });
        }
    },

    updateAndReCommitForm(){
        let msg = this.validateForm();
        if ((msg||"").length > 0) {
            this.$Message.error({
                content:msg
            })
            return 
        }
        let _this = this;
        this.saveBtnIsDisabled = true;
        this.saveAndProcessBtnText = "处理中...";
        let loading = this.$Message.loading({
                    content: '正在处理...',
                    duration: 0
                });
        this.$http.post({
            method: "mqms/moduledist/reupdaterequestbydid",
            params: this.formItem,
            success: function (data) {
                setTimeout(loading, 0);
                _this.saveBtnIsDisabled = false;
                _this.saveAndProcessBtnText = "保存并提交至审核";

                _this.$Message.success({
                    content:"保存成功"
                })
                _this.$router.push({
                    name:"formrequestdetail",
                    params:{id:_this.formItem.id}
                })
            },
            failure(code, errMsg) {
                _this.saveBtnIsDisabled = false;
                _this.saveAndProcessBtnText = "保存并提交至审核";
                setTimeout(loading, 0);

                _this.$Message.error({
                    content:errMsg||"处理失败"
                })
            },
        });
    },


    clearUploadList(){
        this.uploadList = [];
        this.filePushUpload.result = {};
    },
    onAttachUploadSuccess (res, file, fileList) {
        this.uploadList = fileList;
        this.filePushUpload.result = res.data;
    },
    onAttachUploadError (error) {
        this.$Notice.warning({
            title: '上传失败',
            desc:error
        });
    },

    savingAndProcess(){
        let moduleid = this.$route.params.id || "";

        this.savingBtnIsDisabled = true;
        this.savingBtnText = "处理中...";
        let _this = this;
        this.$http.post({
            method: "mqms/moduledist/nextsaveandexamine",
            params: {
                id:moduleid,
                mark:this.examineForm.mark,
                file:this.filePushUpload.result,
            },
            success: function (data) {
                _this.saveBtnIsDisabled = false;
                _this.saveBtnText = "提交至审核";
                _this.$router.push({
                    name:"formrequestdetail",
                    params:{id:moduleid}
                })
            },
            failure(code, errMsg) {
                _this.saveBtnIsDisabled = false;
                _this.saveBtnText = "提交至审核";
                _this.$Message.error({
                    content:errMsg||"操作失败"
                })
            },
        })
    },
  },
  created() {
    this.initRuntimeRole();
  },
};
</script>